 //For m3 conversion fixed fileds
const _calorificValue = 38;
const _correctionFactor = 1.02264;
const _kWhConversionFactor = 3.6;

const unitConversions = {
    // kWh base
    kWhToMWh: function (kWh) {
        return kWh / 1000;
    },
    kWhToMW: function (kWh, numberOfDays, isPeakload) {
        return kWh / numberOfDays / (!isPeakload? 24:12) / 1000;
    },
    kWhToTherms: function (kWh) {
        return kWh / 29.3071;
    },
    kWhToThermsPerDay: function (kWh, numberOfDays) {
        return kWh / numberOfDays / 29.3071;
    },
    kWhToMmbtu: function (kWh) {
        return kWh / 293.071;
    }, 
    kWhToM3: function (kWh ) {
        return kWh * _calorificValue / _correctionFactor * _kWhConversionFactor;
    },
     
    // MWh base
    MWhTokWh: function (MWh) {
        return MWh * 1000;
    },
    MWhToMW: function (MWh, numberOfDays, isPeakload) {
        return MWh / numberOfDays / (!isPeakload ? 24 : 12);
    },
    MWhToTherms: function (MWh) {
        return MWh / 0.0293071;
    },
    MWhToThermsPerDay: function (MWh, numberOfDays) {
        return MWh / numberOfDays / 0.2931;
    },
    MWhToMmbtu: function (MWh) {
        return MWh / 0.293071;
    }, 
    MWhToM3: function (MWh ) {
        return MWh / calorificValue / correctionFactor * kWhConversionFactor * 1000;
    },
   

    // MW base
    MWTokWh: function (MW, numberOfDays, isPeakload) {
        return MW * numberOfDays * (!isPeakload ? 24 : 12) * 1000;
    },
    MWToMWh: function (MW, numberOfDays, isPeakload) {
        return MW * numberOfDays * (!isPeakload ? 24 : 12);
    },
    MWToTherms: function (MW, numberOfDays, isPeakload) {
        return MW * numberOfDays * (!isPeakload ? 24 : 12) * 34.12142;
    },
    MWToThermsPerDay: function (MW) {
        return MW / 0.04167 / 0.0293071;
    },
    MWToMmbtu: function (MW, numberOfDays, isPeakload) {
        return MW * numberOfDays * (!isPeakload ? 24 : 12) * 3.412142;
    }, 
     MWToM3: function (MW, numberOfDays) {
         return MW / _calorificValue / _correctionFactor * _kWhConversionFactor * 1000 * numberOfDays * 24;
    },
   
    // therms base
    thermsTokWh: function (therms) {
        return therms * 29.3071;
    },
    thermsToMWh: function (therms) {
        return therms * 0.0293071;
    },
    thermsToMW: function (therms, numberOfDays, isPeakload) {
        return therms / numberOfDays / (!isPeakload ? 24 : 12) / 34.12124;
    },
    thermsToThermsPerDay: function (therms, numberOfDays) {
        return therms / numberOfDays;
    },
    thermsToMmbtu: function (therms) {
        return therms / 10;
    }, 
     thermsToM3: function (therm) {
         return therm / _calorificValue / _correctionFactor * _kWhConversionFactor * 29.3071;
    },
  

    // th/d base
    thermsPerDayTokWh: function (thermsPerDay, numberOfDays) {
        return thermsPerDay * numberOfDays * 29.3071;
    },
    thermsPerDayToMWh: function (thermsPerDay, numberOfDays) {
        return thermsPerDay * numberOfDays * 0.0293071;
    },
    thermsPerDayToMW: function (thermsPerDay) {
        return thermsPerDay * 0.0293071 * 0.04167;
    },
    thermsPerDayToTherms: function (thermsPerDay, numberOfDays) {
        return thermsPerDay * numberOfDays;
    },
    thermsPerDayToMmbtu: function (thermsPerDay, numberOfDays) {
        return thermsPerDay * numberOfDays * 0.1;
    }, 
      thermsPerDayToM3: function (thermsPerDay, numberOfDays ) {
          return thermsPerDay / _calorificValue / _correctionFactor * _kWhConversionFactor * numberOfDays * 29.3071;
    },
   

    // mmbtu base
    mmbtuTokWh: function (mmbtu) {
        return mmbtu * 293.071;
    },
    mmbtuToMWh: function (mmbtu) {
        return mmbtu * 0.293071;
    },
    mmbtuToMW: function (mmbtu, numberOfDays, isPeakload) {
        return mmbtu / numberOfDays / (!isPeakload ? 24 : 12) / 3.412124;
    },
    mmbtuToTherms: function (mmbtu) {
        return mmbtu * 10;
    },
    mmbtuToThermsPerDay: function (mmbtu, numberOfDays) {
        return mmbtu / numberOfDays / 0.1;
    },
    mmbtuToM3: function (mmbtu) {
        return mmbtu / _calorificValue / _correctionFactor * _kWhConversionFactor * 293.071;
    },


    m3TokWh: function (m3b ) {
        return m3b * _calorificValue * _correctionFactor / _kWhConversionFactor;
    },
    m3ToMWh: function (m3b ) {
        return m3b * _calorificValue * _correctionFactor / _kWhConversionFactor / 1000;
    },
    m3ToMW: function (m3b, numberOfDays ) {
        return m3b * _calorificValue * _correctionFactor / _kWhConversionFactor / 1000 / numberOfDays / 24;
    },
    m3ToTherms: function (m3b ) {
        return m3b * _calorificValue * _correctionFactor / _kWhConversionFactor / 29.3071;
    },
    m3ToThermsPerDay: function (m3b, numberOfDays) {
        return m3b * _calorificValue * _correctionFactor / _kWhConversionFactor / numberOfDays / 29.3071;
    },
    m3ToMmbtu: function (m3b ) {
        return m3b * _calorificValue * _correctionFactor / _kWhConversionFactor / 293.071;
    },

    




    // percentage
    percentageToUnit: function (percentage, total) {
        return (percentage / 100) * total;
    },
    unitToPercentage: function (part, total) {
        if (total === 0) {
            return 0;
        }
        return (part / total) * 100;
    },

    /**
     * Converts values from one unit to another
     * @param {any} inputValue - the input value in the original unit
     * @param {any} inputUnit - the original unit from which the value is being converted to
     * @param {any} outputUnit - the unit to which the value is being converted to
     * @param {any} numberOfDays - default: 30
     * @param {any} totalAvailableValue - default: 0, used for calculating percentages
     */
    convert: function (inputValue, inputUnit, outputUnit, numberOfDays = 30, isPeakload = false) {
        if (inputUnit == "m\u00B3") {
            inputUnit = "m3";
        } 
        if (outputUnit == "m\u00B3") {
            outputUnit = "m3";
        }
             
        switch (inputUnit) {
            case 'therm':
                switch (outputUnit) {
                    case 'kWh':
                        return this.thermsTokWh(inputValue);
                        break;
                    case 'MWh':
                        return this.thermsToMWh(inputValue);
                        break;
                    case 'MW':
                        return this.thermsToMW(inputValue, numberOfDays, isPeakload);
                        break;
                    case 'th/d':
                        return this.thermsToThermsPerDay(inputValue, numberOfDays);
                        break;
                    case 'mmbtu':
                        return this.thermsToMmbtu(inputValue)
                        break;
                    case 'm3':
                        return this.thermsTom3(inputValue);
                        break;
                    default:
                        return inputValue;
                        break;
                }
            case 'kWh':
                switch (outputUnit) {
                    case 'MWh':
                        return this.kWhToMWh(inputValue);
                        break;
                    case 'MW':
                        return this.kWhToMW(inputValue, numberOfDays, isPeakload);
                        break;
                    case 'therm':
                        return this.kWhToTherms(inputValue);
                        break;
                    case 'th/d':
                        return this.kWhToThermsPerDay(inputValue, numberOfDays);
                        break;
                    case 'mmbtu':
                        return this.kWhToMmbtu(inputValue);
                        break;
                    case 'm3':
                        return this.kWhTom3(inputValue);
                        break;
                    default:
                        return inputValue;
                        break;
                }
            case 'MWh':
                switch (outputUnit) {
                    case 'kWh':
                        return this.MWhTokWh(inputValue);
                        break;
                    case 'MW':
                        return this.MWhToMW(inputValue, numberOfDays, isPeakload);
                        break;
                    case 'therm':
                        return this.MWhToTherms(inputValue);
                        break;
                    case 'th/d':
                        return this.MWhToThermsPerDay(inputValue, numberOfDays);
                        break;
                    case 'mmbtu':
                        return this.MWhToMmbtu(inputValue);
                        break;
                    case 'm3':
                        return this.MWhTom3(inputValue);
                        break;
                    default:
                        return inputValue;
                        break;
                }
            case 'MW':
                switch (outputUnit) {
                    case 'kWh':
                        return this.MWTokWh(inputValue, numberOfDays, isPeakload);
                        break;
                    case 'MWh':
                        return this.MWToMWh(inputValue, numberOfDays, isPeakload);
                        break;
                    case 'therm':
                        return this.MWToTherms(inputValue, numberOfDays, isPeakload);
                        break;
                    case 'th/d':
                        return this.MWToThermsPerDay(inputValue);
                        break;
                    case 'mmbtu':
                        return this.MWToMmbtu(inputValue, numberOfDays, isPeakload);
                        break;
                    case 'm3':
                        return this.MWTom3(inputValue, numberOfDays);
                        break;
                    default:
                        return inputValue;
                        break;
                }
            case 'mmbtu':
                switch (outputUnit) {
                    case 'kWh':
                        return this.mmbtuTokWh(inputValue);
                        break;
                    case 'MWh':
                        return this.mmbtuToMWh(inputValue);
                        break;
                    case 'MW':
                        return this.mmbtuToMW(inputValue, numberOfDays, isPeakload);
                        break;
                    case 'th/d':
                        return this.mmbtuToThermsPerDay(inputValue, numberOfDays);
                        break;
                    case 'therm':
                        return this.mmbtuToTherms(inputValue)
                        break;
                    case 'm3':
                        return this.mmbtuToM3(inputValue)
                        break;
                    default:
                        return inputValue;
                        break;
                }
            case 'th/d':
                switch (outputUnit) {
                    case 'kWh':
                        return this.thermsPerDayTokWh(inputValue, numberOfDays);
                        break;
                    case 'MWh':
                        return this.thermsPerDayToMWh(inputValue, numberOfDays);
                        break;
                    case 'MW':
                        return this.thermsPerDayToMW(inputValue);
                        break;
                    case 'therm':
                        return this.thermsPerDayToTherms(inputValue, numberOfDays);
                        break;
                    case 'mmbtu':
                        return this.thermsPerDayToMmbtu(inputValue, numberOfDays);
                        break;
                    case 'm3':
                        return this.thermsPerDayTom3(inputValue, numberOfDays);
                        break;
                    default:
                        return inputValue;
                        break;
                }
            case 'm3':
                switch (outputUnit) {
                    case 'kWh':
                        return this.m3TokWh(inputValue );
                    case 'MWh':
                        return this.m3ToMWh(inputValue );
                    case 'MW':
                        return this.m3ToMW(inputValue, numberOfDays );
                    case 'therm':
                        return this.m3ToTherms(inputValue );
                    case 'th/d':
                        return this.m3ToThermsPerDay(inputValue, numberOfDays );
                    case 'mmbtu':
                        return this.m3ToMmbtu(inputValue );
                    default:
                        return inputValue;
                }
            default:
                return inputValue;
                break;
        }
    }
}

export default unitConversions;